const getters = {
  usuario: (state) => state.usuario
}

export default getters
